module.exports = __webpack_public_path__ + "static/media/miniräknara-min.2a246844.png";